const masqueIban = (iban: string) => {
	return iban.replace(/(.{4})/g, '$1 ')
}

export default masqueIban
